module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074ab_logo_200x200.ba077b4c.png";